import React, { useEffect } from "react"

//Types
import DragAndUploadFileModule, { XLSXFormatFile } from "@/UI/Inputs/DragAndUploadFileModule"
import { Button, message, Modal, Progress } from "antd"

import KosmoButton from "@/UI/Buttons/KosmoButton"
import { useTranslation } from "react-i18next"
import { useTeams } from "@/hooks/useTeams"
import { useDrivers } from "@/hooks/useDrivers"
import { useUploadTemplate } from "./template/useUploadTemplate"
import UploadTemplateActionsButton from "./template/uploadTemplateActionButtons"

const DriverUpload: React.FC<{
  open: boolean
  onClose: () => void
}> = ({ open, onClose }) => {
  const { t } = useTranslation()
  const { fetchDrivers } = useDrivers()
  const { fetchTeams } = useTeams()

  useEffect(() => {
    fetchTeams(true)
  }, [])

  const { processTemplateFile, isLoading, isDisabled, file, progressPercent, setFile } =
    useUploadTemplate()

  const handleNext = async () => {
    try {
      await processTemplateFile(fetchDrivers)
      onClose()
      message.success(t("common.driverUpload.uploadSuccessMessage"))
    } catch (err: any) {}
  }

  return (
    <Modal
      open={open}
      title={
        <div className="flex justify-between w-[95%]">
          {t("common.importFile")}
          <UploadTemplateActionsButton />
        </div>
      }
      onCancel={onClose}
      footer={[
        <div className="flex flex-col">
          <div className="flex justify-end ">
            <Button className="" onClick={onClose}>
              {t("common.cancel")}
            </Button>
            <KosmoButton
              id="draft-order-upload-next-step"
              classname="ml-2"
              isDisabled={!file.length || isDisabled}
              isLoading={isLoading}
              onClick={handleNext}
              type="primary"
            >
              {t("new-orders.DraftOrderUpload.uploadAndPreview")}
            </KosmoButton>
          </div>
          {isLoading && (
            <div className="flex mt-2">
              <Progress percent={progressPercent} strokeColor={"#4100FF"} />
            </div>
          )}
        </div>,
      ]}
    >
      <div className={`flex flex-col w-full space-y-4 items-center`}>
        <DragAndUploadFileModule
          file={file}
          setFile={(file) => {
            setFile(file)
          }}
          isDisabled={isLoading}
          supportedFileTypes={[XLSXFormatFile]}
          hint={t("drivers.DriverUploadModal.uploadMaxSize")}
        />
      </div>
    </Modal>
  )
}
export default DriverUpload
